import React from 'react';
import {
  BodyStyled,
  CondicaoStyled,
  ContainerTermosStyled,
  HeaderStyled,
  TituloStyled,
} from "./style";
import { ReactComponent as BtnFechar } from 'assets/img/x-icon.svg';
import ButtonLogin from 'components/ButtonLogin/ButtonLogin';
import Loader from 'components/Login/Loader/Loader';
import { termos } from './termos-data';
import { aceitarTermosDeUso } from 'services/login/termo-de-uso/termo-de-uso';
import { useLoginContext } from 'context/login-context';
import { useLoginHook } from 'hooks/login-hook';
import { ScrollbarTermsStyled } from './scrollbarStyle';

const TermosDeUso = () => {

  const {
    isLoading,
    setCheckboxTerms,
    setShowTermsUse,
    setIsLoading,
    redirectToLogin,
    keys,
  } = useLoginContext();
  const loginHook = useLoginHook();


  const AceitarTermoUso = async (event) => {
    setIsLoading(true);
    event.preventDefault();
    const userIsLoggedIn = keys.every(key => localStorage.getItem(key));
    try {
      if (userIsLoggedIn) {
        await aceitarTermosDeUso();
        await loginHook.realizarRedirect();
      } else {
        setShowTermsUse(false);
        setCheckboxTerms({
          isChecked: true,
          showCheckbox: true,
        });
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }

  return (
    <ContainerTermosStyled>
      <HeaderStyled>
        <TituloStyled>
          <h1>Termos de uso</h1>
          <p>do Portal de Instituições de Ensino (PIE)</p>
        </TituloStyled>

        <BtnFechar
          width={10}
          height={10}
          className='btn-fechar'
          id='fechar-modal-termos'
          onClick={redirectToLogin}
        />
      </HeaderStyled>
      <BodyStyled>
        <ScrollbarTermsStyled />
        <p className='subtitle'>
          <span>Bem-vindo(a)!</span>
          Antes de começar, é importante que você leia e compreenda estes Termos. Ao acessar ou utilizar o Portal, você concorda com os termos e condições descritos abaixo.
        </p>
        {
          termos.map((condicao) => (
            <CondicaoStyled key={condicao.id}>
              <h4 className='titulo-condicao'>{`${condicao.id}. ${condicao.titulo}`}</h4>
              <p className='corpo-condicao' dangerouslySetInnerHTML={{ __html: condicao.texto }}></p>
            </CondicaoStyled>
          ))
        }
      </BodyStyled>

      <ButtonLogin
        id='btn-aceite-termos'
        label='Li e concordo'
        onClick={AceitarTermoUso}
        disabled={isLoading}
        type='with-icon'
        icon={isLoading ? <Loader className='loader' /> : ''}
      />
    </ContainerTermosStyled>


  )
}

export default TermosDeUso;